export const APP_VERSION = {
  CURRENT: "2.0.0",
};
